import * as S from "./style";

const BestPriceBanner = () => {
  return (
    <S.BannerRoot>
      <S.BannerInner>
        <S.BannerText>Buy And Sell With The Best Price</S.BannerText>
      </S.BannerInner>
    </S.BannerRoot>
  );
};

export default BestPriceBanner;
